import React from "react"

function IconTable({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="table"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-table"
      {...props}
    >
      <path
        d="M19 3.4a1.6 1.6 0 0 1 1.593 1.454L20.6 5v14a1.6 1.6 0 0 1-1.454 1.593L19 20.6H5a1.6 1.6 0 0 1-1.593-1.454L3.4 19V5a1.6 1.6 0 0 1 1.454-1.593L5 3.4h14zM8.9 11.099H4.599L4.6 19a.4.4 0 0 0 .32.392L5 19.4h3.9v-8.301zm10.5 0h-9.301V19.4H19a.4.4 0 0 0 .392-.32L19.4 19v-7.901zm-10.5-6.5L5 4.6a.4.4 0 0 0-.392.32L4.6 5l-.001 4.9H8.9V4.599zM19 4.6l-8.901-.001V9.9H19.4V5a.4.4 0 0 0-.32-.392L19 4.6z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconTable
